var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon07({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15H17M7 18H13M21 6V18C21 18.3453 21 18.6804 21 19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19C3 18.6804 3 18.3453 3 18V6C3 5.6547 3 5.31962 3 5C3 3.34314 4.34315 2 6 2H18C19.6569 2 21 3.34314 21 5C21 5.31962 21 5.6547 21 6ZM10.0511 7.5199L7.6842 7.01593L9.23055 11.2222L15.6738 10.0299L15.6842 5.42644L13.5698 6.8027L11.487 5L10.0511 7.5199Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon07);
export default __webpack_public_path__ + "static/media/icon07.fe613ff708ce639d4a23c830aaa06b61.svg";
export { ForwardRef as ReactComponent };